import { styled } from '@material-ui/core';

export const Container = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  color: theme.colors.black,
}));
